import React, { useReducer, useState } from 'react'
import { useDispatch } from 'react-redux';
import styles from "../Aibox/AiboxForm.module.css"
import { Button } from 'primereact/button';
import Lottie from 'lottie-react';
import fail from '../../../../../../assets/animations/fail.json'
import success from '../../../../../../assets/animations/success.json'
import { deleteLiveViewCamera, addLiveViewCamera } from '../../../../../../Api Methods/Api';

const TextReducer = (state, action) => {
    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    return state;
}

const LiveViewCameraEditForm = ({ camera, apiData, siteUUID, onClose, refreshDevices }) => {
    const dispatch = useDispatch();

    const [step, setStep] = useState('form');
    const [failReason, setFailReason] = useState("");

    const [nameState, dispatchNameState] = useReducer(TextReducer, {
        value: camera?.name ?? '',
        isValid: true
    });

    const [rtspURLState, dispatchRtspURLState] = useReducer(TextReducer, {
        value: camera?.rtspURL ?? '',
        isValid: true
    });

    const submitHandler = async (event) => {
        event.preventDefault();
        setStep('saving');

        const unlinkResponse = await deleteLiveViewCamera(apiData, camera.id, dispatch);
        if (!unlinkResponse.success) {
            setFailReason("Failed to unlink the existing camera, please try again");
            setStep('fail');
            return;
        }

        const relinkBody = {
            siteUUID,
            cameras: [
                {
                    name: nameState.value,
                    rtspURL: rtspURLState.value,
                    type: camera.type,
                    defaultPinned: camera.defaultPinned ?? 0
                }
            ]
        };

        const relinkResponse = await addLiveViewCamera(apiData, relinkBody, dispatch);
        if (relinkResponse.success) {
            setStep('success');
        } else {
            setFailReason("The existing camera was unlinked but relinking with the new details failed - please add it again manually");
            setStep('fail');
        }
    };

    if (step === 'success') {
        return (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <h3 style={{ textAlign: "center", color: "#858585" }}>Live view camera updated successfully!</h3>
                <Lottie animationData={success} loop={false} style={{ width: 250, height: 250, margin: "0px" }} />
                <Button
                    onClick={() => { refreshDevices?.(); onClose?.(); }}
                    style={{ width: "100%" }}
                    severity='secondary'
                    label='Close'
                    icon="pi pi-times"
                />
            </div>
        );
    }

    if (step === 'fail') {
        return (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie animationData={fail} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
                <h3 style={{ textAlign: "center", color: "#6e6e6eff" }}>{failReason}</h3>
                <Button icon="pi pi-times" onClick={() => setStep('form')} label="Try again" severity='secondary' />
            </div>
        );
    }

    return (
        <form onSubmit={submitHandler} className={styles["container1"]}>
            <h3 style={{ color: "#6e6e6e" }}>Edit live view camera</h3>
            <br />

            <input
                placeholder="Camera name"
                value={nameState.value}
                onChange={(e) => dispatchNameState({ type: 'USER_INPUT', val: e.target.value })}
                type="text"
                className={styles.inputField}
                required
            />

            <input
                placeholder="Stream URL"
                value={rtspURLState.value}
                onChange={(e) => dispatchRtspURLState({ type: 'USER_INPUT', val: e.target.value })}
                type="text"
                className={styles.inputField}
                required
            />

            <br/>
            <Button
                icon="pi pi-save"
                severity="success"
                type="submit"
                disabled={step === 'saving'}
                label={step === 'saving' ? "Saving..." : "Save"}
            />
        </form>
    );
}

export default LiveViewCameraEditForm;
